import HTTP from '../HTTP';

const URL_BASE = 'gescom/Affectation/';

export async function getAffectationProduitUnitaireAsync(faces, avecTarif, avecAffectationReseau) {
  const response = await HTTP.post(URL_BASE + 'PGetAffectationProduitUnitaireAsync', { produits: faces, avecTarif, avecAffectationReseau });
  return response;
}

export async function getAffectationProduitReseauLc(params, avecTarif) {
  const response = await HTTP.post(URL_BASE + 'PGetAffectationProduitReseauLcAsync', params, { params: { avecTarif } });
  return response;
}

export async function getAffectationProduitReseauMairie(params, avecTarif) {
  const response = await HTTP.post(URL_BASE + 'PGetAffectationProduitReseauMairieAsync', params, { params: { avecTarif } });
  return response;
}

export async function getAffectationProduitReseauTempo(parameters, avecOption, avecTarif,
  avecAnnule) {
  const response = await HTTP.post(URL_BASE + 'PGetAffectationProduitReseauTempoAsync', parameters, { params: { avecOption, avecTarif, avecAnnule } });
  return response;
}

export async function getAffectationEcranNumerique(params, avecTarif) {
  const response = await HTTP.post(URL_BASE + 'PGetAffectationProduitEcranNumeriqueAsync', params, { params: { avecTarif } });
  return response;
}

export async function getAffectationReseauNumerique(params, avecTarif) {
  const response = await HTTP.post(URL_BASE + 'PGetAffectationProduitReseauNumeriqueAsync', params, { params: { avecTarif } });
  return response;
}
